import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { direction: String }
  }

  connect() {
    const table = this.element

    table.addEventListener("scroll", () => {
      if (table.scrollLeft === 0) {
        table.dataset.horizontalScrollPosition = "start"
      } else if (table.scrollLeft + table.offsetWidth >= table.scrollWidth) {
        table.dataset.horizontalScrollPosition = "end"
      } else {
        table.dataset.horizontalScrollPosition = "scrolling"
      }
    })
  }
}
